import { useFeatureFlags } from "Shared/FeatureFlags";

export const useIsAutocompletedAddressFeatureEnabled = () => {
  const { flags } = useFeatureFlags();

  const isAutocompletedFeatureFlagEnabled = !!flags.autocomplete;

  return isAutocompletedFeatureFlagEnabled;
};
